import { render, staticRenderFns } from "./VerifyVoteModal.vue?vue&type=template&id=661531de&"
import script from "./VerifyVoteModal.vue?vue&type=script&lang=ts&"
export * from "./VerifyVoteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports